import SidenavController from './sidenav.controller';


let sidenavModule = angular.module('demo.sidenav', []);

sidenavModule.controller('SidenavController', SidenavController);

export default sidenavModule = sidenavModule.name
